var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isValidOffer)?_c('v-alert',{attrs:{"border":"top","color":"green lighten-2","dark":""}},[_vm._v(" This offer still valid. ")]):_c('v-alert',{attrs:{"border":"top","color":"red ligthen-2","dark":""}},[_vm._v(" This offer is not valid. "+_vm._s(_vm.invalidReason)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }